/**
 * Composition hook for Black Friday page
 *
 * Combines data fetching with UI state (selected category).
 * Auto-selects first category when data loads.
 */

import { useState, useEffect } from 'react'

import { useBlackFridayData } from './useBlackFridayData'

import type { BlackFridayContextValue } from '../../types/domain'

export function useBlackFridayState(): BlackFridayContextValue {
  const { categories, categoryNames, blockData1, blockData2, loading, error } =
    useBlackFridayData()

  const [selectedCategory, setSelectedCategory] =
    useState<BlackFridayContextValue['selectedCategory']>(null)

  // Auto-select first category when data arrives
  useEffect(() => {
    if (categories.length > 0 && !selectedCategory) {
      setSelectedCategory(categories[0])
    }
  }, [categories, selectedCategory])

  function handleCategoryClick(categoryName: string): void {
    const category = categories.find((cat) => cat.name === categoryName)
    setSelectedCategory(category ?? null)
  }

  return {
    categoryNames,
    categories,
    selectedCategory,
    blockData1,
    blockData2,
    loading,
    error,
    handleCategoryClick,
  }
}
